export enum ESalaryRange {
  'FROM_500_TO_1000' = '500-1000',
  'FROM_1000_TO_2000' = '1000-2000',
  'FROM_2000_TO_3000' = '2000-3000',
  'FROM_3000_TO_4000' = '3000-4000',
  'FROM_4000_TO_6000' = '4000-6000',
  'FROM_6000_TO_8000' = '6000-8000',
  'FROM_8000_TO_10000' = '8000-10000',
  'MORE_THAN_10000' = '10000+'
}

export const SALARY_RANGES = Object.values(ESalaryRange);
